import { render, staticRenderFns } from "./link-invalid.vue?vue&type=template&id=55e90fec&scoped=true"
import script from "./link-invalid.vue?vue&type=script&lang=js"
export * from "./link-invalid.vue?vue&type=script&lang=js"
import style0 from "./link-invalid.vue?vue&type=style&index=0&id=55e90fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e90fec",
  null
  
)

export default component.exports